<template>
  <div 
    v-if="isVisible" 
    class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[9999] p-4"
  >
    <div class="flex flex-col w-full max-w-[732px] max-h-[90vh] bg-white rounded-lg overflow-hidden">
      <!-- Modal Header -->
      <div class="flex justify-end items-center pt-4 px-4">
        <button 
          type="button" 
          @click="$emit('cancel')"
          class="bg-transparent border-none w-5 h-5 cursor-pointer p-0"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M15 5L5 15M5 5L15 15" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <!-- Modal Body - Scrolleable -->
      <div class="flex-1 overflow-y-auto px-6 py-5">
        <div class="flex flex-col gap-5">
          
          <!-- Icono (centrado) y Título -->
          <div class="flex flex-col gap-4 w-full">
            <!-- Icono centrado -->
            <div class="flex justify-center">
              <div class="relative w-10 h-10">
                <div class="w-10 h-10 bg-[#FF4265] rounded-full"></div>
                <div class="absolute left-[5px] top-[5px] w-7 h-7">
                  <svg class="w-6 h-6 absolute left-[3.75px] top-[3.75px]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="white"/>
                  </svg>
                </div>
              </div>
            </div>
            
            <!-- Título y subtítulo alineados a la izquierda -->
            <div class="flex flex-col gap-2 w-full">
              <h2 class="text-left text-2xl md:text-[24px] font-semibold font-['Poppins'] leading-9">
                <span class="text-[#FF4265]">Acceso Premium</span>
                <span class="text-gray-800"> para asesores</span>
              </h2>
              
              <p class="text-left text-gray-800 text-sm md:text-base font-normal font-['Poppins'] leading-6">
                Tu perfil es solo el inicio. Obtén acceso completo a las herramientas que usan los asesores más exitosos para crecer, profesionalizarse y vender más.
              </p>
            </div>
          </div>

          <!-- Beneficios -->
          <div class="flex flex-col gap-6">
            <h3 class="text-left text-[#FF4265] text-lg font-semibold font-['Poppins'] leading-7">
              Beneficios principales
            </h3>

            <!-- Beneficio 1 -->
            <div class="flex flex-col md:flex-row gap-4 items-center">
              <!-- Texto primero en móvil -->
              <div class="flex-1 flex flex-col gap-2 text-left md:order-2">
                <h4 class="text-lg font-semibold font-['Poppins'] leading-7">
                  <span class="text-gray-800">1. </span>
                  <span class="text-[#FF4265]">Administra</span>
                  <span class="text-gray-800"> todas tus propiedades</span>
                </h4>
                
                <p class="text-gray-700 text-sm md:text-base font-normal font-['Poppins'] leading-6">
                  <span class="font-semibold">Crea, edita y organiza</span> tus propiedades desde un solo lugar. Accede a tu panel privado con vista de grid, ficha técnica y control total.
                </p>
              </div>
              
              <!-- Imagen segunda en móvil -->
              <div class="w-full md:w-[285px] h-[180px] md:h-[208px] bg-white rounded-lg overflow-hidden flex items-center justify-center md:order-1">
                <img
                  src="@/assets/imgs/Diseño_1.png"
                  alt="Administra propiedades"
                  class="w-full h-full object-contain"
                />
              </div>
            </div>

            <!-- Beneficio 2 -->
            <div class="flex flex-col md:flex-row gap-4 items-center">
              <!-- Texto primero en móvil -->
              <div class="flex-1 flex flex-col gap-2 text-left">
                <h4 class="text-lg font-semibold font-['Poppins'] leading-7">
                  <span class="text-gray-800">2. </span>
                  <span class="text-[#FF4265]">Personaliza</span>
                  <span class="text-gray-800"> tu presencia profesional</span>
                </h4>
                
                <p class="text-gray-700 text-sm md:text-base font-normal font-['Poppins'] leading-6">
                  Actualiza tu <span class="font-semibold">perfil, tu inmobiliaria y tus datos como asesor.</span> Todo para proyectar una <span class="font-semibold">imagen profesional</span>… sin ser visible en TUIN hasta que decidas dar el salto.
                </p>
              </div>
              
              <!-- Imagen segunda en móvil -->
              <div class="w-full md:w-[285px] h-[180px] md:h-[208px] bg-white rounded-lg overflow-hidden flex items-center justify-center">
                <img
                  src="@/assets/imgs/Diseño_2.png"
                  alt="Personaliza perfil"
                  class="w-full h-full object-contain"
                />
              </div>
            </div>

            <!-- Beneficio 3 -->
            <div class="flex flex-col md:flex-row gap-4 items-center">
              <!-- Texto primero en móvil -->
              <div class="flex-1 flex flex-col gap-2 text-left md:order-2">
                <h4 class="text-lg font-semibold font-['Poppins'] leading-7">
                  <span class="text-gray-800">3. </span>
                  <span class="text-[#FF4265]">Organiza</span>
                  <span class="text-gray-800"> tu negocio de forma privada</span>
                </h4>
                
                <p class="text-gray-700 text-sm md:text-base font-normal font-['Poppins'] leading-6">
                  <span class="font-semibold">Acceso a todas las secciones internas </span>de asesores: tu perfil, tu inmobiliaria, tus fichas técnicas. Todo lo puedes gestionar, aunque aún no aparezcas públicamente en TUIN.
                </p>
              </div>
              
              <!-- Imagen segunda en móvil -->
              <div class="w-full md:w-[285px] h-[180px] md:h-[224px] bg-white rounded-lg overflow-hidden flex items-center justify-center md:order-1">
                <img
                  src="@/assets/imgs/Diseño_3.png"
                  alt="Organiza negocio"
                  class="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Modal Footer -->
      <div class="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-4 p-6 md:py-3 border-t border-gray-100">
        <button 
          @click="$emit('cancel')" 
          class="w-full md:w-32 h-9 px-3 py-2 rounded-lg border border-gray-200 bg-white text-gray-800 text-xs font-medium font-['Inter'] leading-4 cursor-pointer transition-all hover:-translate-y-0.5 active:translate-y-0"
        >
          Cancelar
        </button>
        <button 
          @click="$emit('confirm')" 
          class="w-full md:w-auto px-5 py-2 rounded-lg bg-[#FF4265] text-white text-sm font-medium font-['Inter'] leading-5 border-none cursor-pointer transition-all hover:-translate-y-0.5 active:translate-y-0"
        >
          Suscribirme ahora
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PremiumAccessModal',
  props: {
    isVisible: {
      type: Boolean,
      required: true
    }
  }
}
</script>